/* global gtag */

import DeliveryMethods from "@/modules/delivery-methods";
import { CheckoutStages } from "@/modules/checkout-stages";

import jbs_api from '@/modules/jbs-api';

import store from "./index";

export default {
    namespaced: true,
    state: {
        active_stage: 0,
        mode: 'retail',
        highlight_basket_duty: false,
        delivery_slots: [],
        delivery_estimates: { ib: false, dp: false, ibp: false, dpp: false },
        payment_methods: [],
        credit_limit: 0,
        order_data: {
            billing: {
                address: false,
                method: 'worldpay_corp',
                save_card: false,
                saved_card: false
            },
            delivery: {
                ib: {
                    deliveryMethod: false,
                    deliveryData: {},
                },
                dp: {
                    deliveryMethod: false,
                    deliveryData: {}
                },
                ibp: {
                    deliveryMethod: false,
                    deliveryData: {},
                },
                dpp: {
                    deliveryMethod: false,
                    deliveryData: {}
                }
            }
        }
    },
    getters: {
        stages(state) {
            return CheckoutStages(state.mode, store);
        },
        delivery_methods(state) {
            return DeliveryMethods(state);
        },
        delivery_is_valid(state) {
            return (duty) => {
                if (!state.order_data.delivery[duty]) {
                    return false;
                }

                if (state.order_data.delivery[duty].deliveryMethod == false) {
                    return false;
                }

                if (state.order_data.delivery[duty].deliveryMethod === 'deliverto' || state.order_data.delivery[duty].deliveryMethod === 'shop' || state.order_data.delivery[duty].deliveryMethod === 'warehouse') {
                    if (!state.order_data.delivery[duty].deliveryData) {
                        return false;
                    }

                    if (!state.order_data.delivery[duty].deliveryData.Address1) {
                        return false;
                    }

                    if (!state.order_data.delivery[duty].deliveryData.City) {
                        return false;
                    }

                    if (!state.order_data.delivery[duty].deliveryData.PostCode) {
                        return false;
                    }

                    if (!state.order_data.delivery[duty].deliveryData.Name) {
                        return false;
                    }

                    if (!state.order_data.delivery[duty].deliveryData.Telephone && state.order_data.delivery[duty].deliveryMethod === 'deliverto') {
                        return false;
                    }

                    if (!state.order_data.delivery[duty].deliveryData.Recipient) {
                        return false;
                    }
                }

                if (state.order_data.delivery[duty].deliveryMethod === 'warehouse') {
                    if (!state.order_data.delivery[duty].deliveryData.Acc) {
                        return false;
                    }
                }

                return true;
            }
        }
    },
    mutations: {
        set_mode(state, payload) {
            state.mode = payload;
        },
        set_active_stage(state, payload) {
            if (state.active_stage !== payload) {
                state.active_stage = payload;
            }
        },

        set_highlight_basket(state, payload) {
            state.highlight_basket_duty = payload;
        },
        set_delivery_method(state, payload) {
            const duty = payload.duty.toLowerCase();
            if (!state.order_data.delivery[duty]) {
                state.order_data.delivery[duty] = {
                    deliveryData: {},
                    deliveryMethod: false
                }
            }
            state.order_data.delivery[duty].deliveryMethod = payload.method;
        },
        set_delivery_data(state, payload) {
            const duty = payload.duty.toLowerCase();
            if (!state.order_data.delivery[duty]) {
                state.order_data.delivery[duty] = {
                    deliveryData: {},
                    deliveryMethod: false
                }
            }
            state.order_data.delivery[duty].deliveryData = payload.data;
        },
        set_billing_address(state, payload) {
            state.order_data.billing.address = payload;
        },
        set_order_data(state, payload) {
            state.order_data = payload;
        },
        set_delivery_slots(state, payload) {
            state.delivery_slots = payload;
        },
        set_delivery_estimates(state, payload) {
            state.delivery_estimates = payload;
        },
        set_payment_methods(state, payload) {
            state.payment_methods = payload;
        },
        set_save_card(state, payload) {
            state.order_data.billing.payment.save_card = payload;
        },
        set_saved_card(state, payload) {
            state.order_data.billing.payment.saved_card = payload;
        },
        set_credit_limit(state, payload) {
            state.credit_limit = payload;
        },
        set_payment_method(state, payload) {
            state.order_data.billing.payment.method = payload;
        }
    },
    actions: {
        ga4_add_shipping_info(context) {
            gtag('event', 'add_shipping_info', {
                currency: "GBP",
                value: context.rootState.basket.totals.total,
                coupon: context.rootState.basket.coupons.length > 0 ? context.rootState.basket.coupons[0] : undefined,
                items: context.rootGetters['basket/gtag_items']
            });
        },
        ga4_add_payment_info(context) {
            gtag('event', 'add_payment_info', {
                currency: "GBP",
                value: context.rootState.basket.totals.total,
                coupon: context.rootState.basket.coupons.length > 0 ? context.rootState.basket.coupons[0] : undefined,
                payment_type: context.state.order_data.billing.payment.method,
                items: context.rootGetters['basket/gtag_items']
            });
        },
        get_payment_methods(context) {
            return jbs_api.get('Basket/PaymentMethods').then((response) => {
                context.commit('set_payment_methods', response.data.methods);
                context.commit('set_credit_limit', response.data.credit_limit);
                context.commit('readiness/is_ready', "payment_methods", { root: true });
            });
        },
        forget_card(context, payload) {
            return jbs_api.delete('Basket/PaymentMethods', { params: payload }).then((response) => {
                context.commit('set_payment_methods', response.data.methods);
                context.commit('set_credit_limit', response.data.credit_limit);
            });
        },
        get_delivery_slots(context, payload) {
            return jbs_api.get('Basket/DeliverySlots', { params: { postcode: payload } }).then((response) => {
                context.commit('set_delivery_slots', response.data);
            });
        },
        save_order_data(context) {
            context.commit('readiness/is_not_ready', "checkout_calculations", { root: true });
            return jbs_api.patch('Basket/OrderData', context.state.order_data).then((response) => {
                context.commit('basket/update', response.state, { root: true });
                context.commit('set_delivery_estimates', response.state.delivery_estimates);
            }).finally(() => {
                context.commit('readiness/is_ready', "checkout_calculations", { root: true });
            });
        },
        next_stage(context) {
            context.commit('set_active_stage', context.state.active_stage + 1);
        },
        prev_stage(context) {
            context.commit('set_active_stage', context.state.active_stage - 1);
        },
        make_bill_payment(context, payload) {
            return jbs_api.post('PayBill', payload);
        },
        place_order() {
            return jbs_api.post('PlaceOrder');
        },
        check_order() {
            return jbs_api.get('PlaceOrder');
        }
    },
};